import React from 'react';

/**
 * A component to display a 404 error image or GIF
 * @param {Object} props - Component props
 * @param {string} props.imagePath - Path to the 404 image or GIF
 * @param {string} props.altText - Alt text for the image
 * @param {Object} props.style - Additional inline styles
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element} 404 Error image component
 */
const ErrorGif = ({
  imagePath,
  altText = "404 Page Not Found",
  style = {},
  className = "",
  ...props
}) => {
  // Default styling for the image container
  const containerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    ...style
  };

  // If no image path is provided, show a placeholder
  if (!imagePath) {
    return (
      <div 
        style={containerStyles} 
        className={`error-gif-container ${className}`}
        {...props}
      >
        <div className="w-full aspect-square max-w-md bg-gray-200 rounded-lg flex items-center justify-center">
          <p className="text-gray-500 text-center p-4">
            404 Image Placeholder
          </p>
        </div>
      </div>
    );
  }

  return (
    <div 
      style={containerStyles} 
      className={`error-gif-container ${className}`}
      {...props}
    >
      <img 
        src={imagePath} 
        alt={altText} 
        className="max-w-full h-auto rounded-lg"
        style={{maxWidth: '80%', width: 'auto'}}
      />
    </div>
  );
};

export default ErrorGif;
